export const LOCALES: { id: string; name: string }[] = [
  { id: 'de', name: 'Deutsch' }, // German (most popular)
  { id: 'fr', name: 'Français' }, // French
  { id: 'it', name: 'Italiano' }, // Italian
  { id: 'en', name: 'English' }, // English
  { id: 'es', name: 'Español' }, // Spanish
  { id: 'pt', name: 'Português' }, // Portuguese
  { id: 'sv', name: 'Svenska' }, // Swedish
  { id: 'da', name: 'Dansk' }, // Danish
  { id: 'nl', name: 'Nederlands' }, // Dutch
  { id: 'no', name: 'Norsk' }, // Norwegian
  { id: 'is', name: 'Íslenska' }, // Icelandic
  { id: 'fi', name: 'Suomi' }, // Finnish
  { id: 'et', name: 'Eesti' }, // Estonian
  { id: 'hr', name: 'Hrvatski' }, // Croatian
  { id: 'sk', name: 'Slovenčina' }, // Slovak
  { id: 'sl', name: 'Slovenščina' }, // Slovenian
  { id: 'cs', name: 'Čeština' }, // Czech
  { id: 'hu', name: 'Magyar' }, // Hungarian
  { id: 'tr', name: 'Türkçe' }, // Turkish
];
